import clsx from 'clsx';
import PropTypes from 'prop-types';

import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Empty from '@zenbusiness/zui/Empty';
import ListItem from '@zenbusiness/zui/ListItem';
import Tooltip from '@zenbusiness/zui/Tooltip';

import * as Styled from './MenuItem.style';
import MenuItemBody from './MenuItemBody';
import { MenuItemProps } from './utils/contants';

/**
 * LinkMenuItem
 *
 * @param {import('./MenuItem.ts').NavMenuItem} props
 * @returns {import('react').ReactNode}
 */
function LinkMenuItem(props) {
  const {
    eventProps,
    itemAttributes = {},
    onClick,
    path,
    target,
    tooltip,
    url
  } = props;
  const destination = path || url;

  const handleLinkTracking = useLinkPressedCallback({
    ...eventProps,
    destination
  });

  const handleMenuItemClick = () => {
    handleLinkTracking();
    onClick?.();
    // Allow nav to shrink on mouseOut.
    document.activeElement.blur();
  };

  const menuItemLinkClass = clsx({ 'is-disabled': !!tooltip }, 'menu-item');

  // Handle interally linked menu items.
  if (path) {
    return (
      <Tooltip title={tooltip}>
        <ListItem
          disablePadding
          {...itemAttributes}
        >
          <Styled.Link
            className={menuItemLinkClass}
            end
            onClick={handleMenuItemClick}
            to={path}
          >
            <MenuItemBody {...props} />
          </Styled.Link>
        </ListItem>
      </Tooltip>
    );
  }

  // Handle externally linked menu items.
  if (url) {
    return (
      <Tooltip title={tooltip}>
        <ListItem
          disablePadding
          {...itemAttributes}
        >
          <Styled.ExternalLink
            className={menuItemLinkClass}
            href={url}
            onClick={handleMenuItemClick}
            target={target}
          >
            <MenuItemBody {...props} />
          </Styled.ExternalLink>
        </ListItem>
      </Tooltip>
    );
  }

  return <Empty no-link />;
}

LinkMenuItem.propTypes = {
  ...MenuItemProps,
  isChild: PropTypes.bool,
  expanded: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.shape(MenuItemProps).isRequired)
};

export default LinkMenuItem;
